import { ArrowRight, Lightbulb, ShieldCheck, Zap, Radar } from "lucide-react";
import { Button } from "@/components/ui/button";

const NEXA_LOGO =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_silicom-pro-futbol/artifacts/0fa38b6bc6e57668_nexa_smart_logo_final_horizontal_transparent_clean.webp";

const NEXA_IMAGE =
  "https://images.unsplash.com/photo-1608377205619-03a0b4c4e270?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxzbWFydCUyMGhvbWUlMjBhdXRvbWF0aW9uJTIwbW9kZXJuJTIwbGl2aW5nJTIwcm9vbSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzkyMTU0MTQyfDA&ixlib=rb-4.1.0&q=85";

const NexaSmart = () => (
  <section id="nexasmart" data-testid="nexasmart-section" className="bg-white py-16">
    <div className="mx-auto max-w-7xl px-6">
      <div className="grid overflow-hidden rounded-3xl border border-slate-100 shadow-xl shadow-sky-100/60 lg:grid-cols-2">
        {/* Panel izquierdo: contenido */}
        <div className="relative overflow-hidden bg-gradient-to-br from-[#0a2540] via-[#0d3057] to-[#0a3a5c] p-8 text-white md:p-12">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute -left-16 -top-16 h-56 w-56 rounded-full bg-cyan-400/15 blur-3xl" />
            <div className="absolute -bottom-16 -right-10 h-56 w-56 rounded-full bg-sky-500/15 blur-3xl" />
          </div>
          <div className="relative">
            <div className="inline-flex items-center rounded-full bg-white px-4 py-2 shadow-md" data-testid="nexasmart-logo">
              <img src={NEXA_LOGO} alt="NexaSmart" className="h-8 w-auto md:h-10" loading="lazy" />
            </div>
            <p className="mt-6 text-[11px] font-black uppercase tracking-[0.3em] text-cyan-300">
              Una línea de Silicomlan
            </p>
            <h2 className="mt-3 text-3xl font-black leading-tight tracking-tight md:text-4xl">
              Conectividad que también{" "}
              <span className="bg-gradient-to-r from-cyan-300 to-sky-300 bg-clip-text text-transparent">
                automatiza.
              </span>
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-300 md:text-base">
              NexaSmart ofrece soluciones de automatización, control y monitoreo
              para hogares, empresas y otros espacios, integrando iluminación,
              seguridad, energía, sensores y dispositivos inteligentes.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {[
                { icon: Lightbulb, label: "Iluminación" },
                { icon: ShieldCheck, label: "Seguridad" },
                { icon: Zap, label: "Energía" },
                { icon: Radar, label: "Sensores" },
              ].map(({ icon: Icon, label }) => (
                <span
                  key={label}
                  className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest text-white/85"
                >
                  <Icon className="h-3.5 w-3.5 text-cyan-300" /> {label}
                </span>
              ))}
            </div>
            <Button
              asChild
              data-testid="nexasmart-cta"
              className="group mt-7 rounded-full bg-gradient-to-r from-cyan-400 to-sky-500 px-6 py-6 text-sm font-black uppercase tracking-widest text-[#0a2540] shadow-[0_0_28px_rgba(34,211,238,0.35)] hover:from-cyan-300 hover:to-sky-400"
            >
              <a href="https://nexasmart.com.ar" target="_blank" rel="noreferrer">
                Conocé NexaSmart
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
            </Button>
          </div>
        </div>
        {/* Panel derecho: imagen */}
        <div className="relative min-h-[260px] lg:min-h-0">
          <img
            src={NEXA_IMAGE}
            alt="Control de iluminación de un hogar inteligente desde un celular"
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a2540]/40 via-transparent to-transparent lg:bg-gradient-to-r" />
        </div>
      </div>
    </div>
  </section>
);

export default NexaSmart;
